// extracted by mini-css-extract-plugin
export default {"list":"aspect_list__M0mNx"};